import React from "react";
import styles from "./insLabelValueTooltip.module.scss";
const isLabelValuePair = (item) => Array.isArray(item);
const isSeparator = (item) => !Array.isArray(item) && item.type === "separator";
const isIcon = (item) => !Array.isArray(item) && item.type === "icon";
const isHeader = (item) => !Array.isArray(item) && item.type === "header";
// Check if all items are simple label-value pairs (legacy format)
const isLegacyFormat = (items) => items.every((item) => isLabelValuePair(item));
export const InsLabelValueTooltip = (props) => {
    const items = props.labelValuePairs?.filter((x) => x) ?? [];
    // Use legacy rendering for backward compatibility when only simple pairs
    if (isLegacyFormat(items)) {
        const validPairs = items.filter((pair) => pair[0] && pair[1]);
        return (React.createElement("div", { className: styles.container },
            React.createElement("div", { className: styles.labels }, validPairs.map((pair) => React.createElement("span", { key: `label-${pair[0]}` }, pair[0]))),
            React.createElement("div", { className: styles.values }, validPairs.map((pair) => React.createElement("span", { key: `value-${pair[0]}` }, pair[1])))));
    }
    // New format with support for headers, separators, and icons
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.tooltipContent }, items.map((item) => {
            if (isLabelValuePair(item)) {
                if (!item[0] || !item[1]) {
                    return null;
                }
                return (React.createElement("div", { key: `row-${item[0]}`, className: styles.row },
                    React.createElement("span", { className: styles.label }, item[0]),
                    React.createElement("span", { className: styles.value }, item[1])));
            }
            if (isHeader(item)) {
                return (React.createElement("div", { key: `header-${item.value}`, className: styles.headerRow },
                    React.createElement("span", { className: styles.headerValue }, item.value)));
            }
            if (isSeparator(item)) {
                return React.createElement("div", { key: "separator", className: styles.separator });
            }
            if (isIcon(item)) {
                return (React.createElement("div", { key: `icon-${item.icon}`, className: styles.iconRow },
                    React.createElement("span", { className: `${styles.icon} ${styles[item.icon] ?? ""}` }),
                    item.label && React.createElement("span", { className: styles.iconLabel }, item.label)));
            }
            return null;
        }))));
};
export const InsLabelTooltip = (props) => React.createElement("div", { className: styles.container },
    React.createElement("div", { className: styles.labels }, props.labels.filter((x) => x).map((x) => React.createElement("span", { key: x }, x))));
